import { Toaster } from "react-hot-toast";
import Layout from "../shared/Layout";
import { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { API_URL, baseurl } from "../../_config";

const PlayerRank = () => {
    const [userList, setUserList] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);

    const fetchPlayerRank = async () => {
        try {
            const response = await axios.get(`${baseurl}${API_URL.getPlayersRank}`);
            if (response.status === 200) {
                setUserList(response?.data?.data)
            }
        } catch {
            return null;
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPlayerRank();
    }, []);

    useEffect(() => {
        if (searchTerm) {
            const filtered = userList?.filter(item =>
                (item.firstName && item.firstName.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.contactNumber && item.contactNumber.toString().includes(searchTerm.toString()))
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(userList);
        }
    }, [searchTerm, userList]);

    const columns = [
        {
            name: 'Rank',
            selector: (row) => row.rank,
            sortable: false,
            width: '70px',
        },
        {
            name: 'Name',
            selector: row => (
                <>{row.firstName} {row.lastName}</>
            ),
            sortable: true,
            minWidth: '150px'
        },
        {
            name: 'Contact Number',
            selector: row => row.contactNumber,
            sortable: true,
            minWidth: '150px'
        },
        {
            name: 'Total Score',
            selector: row => row.totalscore,
            sortable: false,
            minWidth: '100px'
        },
        {
            name: 'State',
            selector: row => row.state,
            sortable: false,
            minWidth: '120px'

        }
    ];

    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="right-content-section">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading">
                        <h4 className="mb-0">Players Ranking</h4>
                    </div>
                    <div className="d-md-flex align-items-center justify-content-end">
                        <div className="search-container ">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>

                <div className="datatable mt-4">
                    <DataTable
                        columns={columns}
                        data={filteredData || []}
                        progressPending={loading}
                        progressComponent={<p>Loading...</p>}
                        pagination
                        highlightOnHover
                    />
                </div>
            </div>
        </Layout>
    )
}

export default PlayerRank;